import {session} from '../Utilities/Session.svelte';
import {datatypes} from './models.js';
import * as qs from 'qs';

const BASE_URL = ''

export function getFields(type) {
    return datatypes[type].fields
}

export function doFetch(url, params, query) {
    const defaults = {
        mode: 'same-origin',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            "Content-Type": 'application/json'
        }
    }

    if (!params) {
        params = {}
    }

    for (let key of Object.keys(defaults)) {
        if (!params.hasOwnProperty(key)) {
            params[key] = defaults[key]
        }
    }

    if (query) {
        url += '?' + qs.stringify(query, { indices: false });
    }

    return new Promise((resolve, reject) => {
        fetch(url, params).then((response) => {
            if (response.ok) {
                return resolve(response);
            }

            if (response.status == 401) {
                session.set({
                    loggedIn: false,
                    user: ""
                });
            }

            return reject(response);

        }).catch((error) => {
            console.log(error);
        });
    });
}

export function cloneObj(obj) {
    let clone = JSON.parse(JSON.stringify(obj));
    return clone;
}

export async function getObj(type, id) {
    if (id) {
        return await (await doFetch(datatypes[type].endpoint + id)).json()
    } else {
        let item = {};
        for (let field of datatypes[type].fields) {
            item[field.name] = field.default != undefined ? field.default : ""
        }
        return item
    }
}

export async function getObjects(type, filters) {
    try {
        return (await (await doFetch(datatypes[type].endpoint, {}, filters)).json())
    } catch(response) {
        if (response.status != 401) {
            console.log(response);
        }

        throw new Error(response)
    }
}

export async function deleteObj(type, obj) {
    let url = datatypes[type].endpoint + obj.id;

    return new Promise(async (resolve, reject) => {
        doFetch(url, {
            method: "DELETE"
        }).then(resolve).catch(reject)
    })
}

export async function saveObj(type, obj) {
    let method = "POST";
    let url = datatypes[type].endpoint

    return new Promise(async (resolve, reject) => {

        for (let field of datatypes[type].fields) {
            if (!field.required && obj[field.name] === ""){
                obj[field.name] = null;
            }
        }

        if (obj.id) {
            url = datatypes[type].endpoint + obj.id
        }

        doFetch(BASE_URL + url, {
            method: method,
            body: JSON.stringify(obj)
        }).then(async (response) => {
            response.json().then(data => {
                if (response.ok) {
                    resolve(data);
                } else {
                    reject(data.error);
                }
            })
        }).catch((error) => {
            error.json().then((results) => {
                reject(results.errors)
            });
        });
    })
}

export let api = {
    get: (url) => {
        return fetch(BASE_URL + url)
    }
}